export default __webpack_public_path__ + "static/media/DoitHD_Cel.e17879bd.mp4";